import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { MY_LISTINGS_KEY, MY_PACKAGE_KEY, useFeatureFlag } from '@steelbuy/data-access';
import {
    ListingSellerDraftCollectionDataProvider,
    ListingSellerDraftEntityDataProvider,
} from '@steelbuy/data-provider';
import { Feature } from '@steelbuy/ts-shared';
import { useCreateListingContext } from '../../components/create-listing/CreateListingContext';
import { RoutePath } from '../../router/Routes';

export const CreateListingView = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { createListingData } = location.state || {};
    const createListingContext = useCreateListingContext();
    const [isInitialDataSet, setIsInitialDataSet] = useState(false);
    const queryClient = useQueryClient();
    const { isFeatureSupported } = useFeatureFlag();

    useEffect(() => {
        if (!isFeatureSupported(Feature.SINGLE_LISTING)) {
            navigate(RoutePath.CREATE_BULK_LISTING_WIZARD);
            return;
        }
        if (createListingData) {
            createListingContext.copyFromListing(createListingData);
            setIsInitialDataSet(true);
        }
        queryClient.removeQueries({ queryKey: [MY_LISTINGS_KEY] });
        queryClient.removeQueries({ queryKey: [MY_PACKAGE_KEY] });
    }, []);

    if ((createListingData && !isInitialDataSet) || !isFeatureSupported(Feature.SINGLE_LISTING)) {
        return null;
    }

    return (
        <ListingSellerDraftCollectionDataProvider lazyLoad>
            <ListingSellerDraftEntityDataProvider entityId="" lazyLoad>
                <Outlet />
            </ListingSellerDraftEntityDataProvider>
        </ListingSellerDraftCollectionDataProvider>
    );
};
